import { __decorate } from "tslib";
import { Group, Vector3 } from 'three';
import { MeasurementLineConfig as Config } from '../Config/MeasurementLineConfig.js';
import { ToolType } from '../Core/ITool.js';
import { Save, SaveChild } from '../Core/Save.js';
import { ViewType } from '../Models/AppModel.js';
import { Consts } from '../Utils/Consts.js';
import { Default } from '../Utils/Default.js';
import { FormatUtils } from '../Utils/FormatUtils.js';
import { DraggablePoint } from './Primitive/DraggablePoint.js';
import { LabelText } from './Primitive/Label/LabelText.js';
import { LinePointToPoint2 } from './Primitive/LinePointToPoint2.js';
import { isBitSet } from '../Utils/Utils.js';
import { StateTypes } from '../States/State.js';
/**
 * Line mesh with length label.
 */
export class MeasurementLine extends Group {
    get distance() {
        return Math.round(this.A.position.distanceTo(this.B.position));
    }
    onSelect() {
        Default.colorAllDraggablePoints(this);
    }
    onDeselect() {
        Default.restoreColorAllDraggablePoints(this);
    }
    constructor(viewType, index, A, B) {
        super();
        this.toolType = ToolType.line;
        this.isSelectable = true;
        this.isDeletable = true;
        this.isSelected = false;
        this._pan = new Vector3();
        this.onAfterRestore = () => {
            this.update();
        };
        this.name = 'MeasurementLine';
        this.position.z = 10;
        this.add(this.A = new DraggablePoint('A', viewType, Config.A_color, A), this.B = new DraggablePoint('B', viewType, Config.B_color, B), this.C = new DraggablePoint('C', viewType, Config.C_color, this.A.position.clone().lerp(this.B.position, 0.5)), this.ABLine = new LinePointToPoint2('ABLine', viewType, Config.ABLine_color, this.A, this.B), this.lengthLabel = new LabelText({
            name: 'lengthLabel',
            viewType,
            objToAnchor: this.C,
            anchor: new Vector3(0, 5),
            color: Config.C_color, //todo conf
            labelParams: {
                backgroundColor: Config.lengthLabel_backgroundColor,
                fontColor: Config.lengthLabel_fontColor,
            }
        }));
        this.update();
        this.bindEvents();
        const isRegisteringClick = viewType === ViewType.AP ? 'isRegisteringClickAP' : 'isRegisteringClickLT';
        const mask = viewType === ViewType.AP ? "linesMaskAP" : "linesMaskLT";
        this.bindProperty("visible", (m) => {
            return !m[isRegisteringClick] && m.layer_lines && isBitSet(m[mask], index) && m.appState > StateTypes.calibrated && !m.isViewPlanPrinting;
        }, [isRegisteringClick, 'layer_lines', mask, 'appState', 'isViewPlanPrinting']);
        this.bindProperty("isEnabled", (m) => { return !m.readonly; }, ['readonly']);
    }
    bindEvents() {
        this.bindEvent('onAfterDragMove', () => {
            this.update();
        });
        this.A.bindEvent('onDragMove', (args) => {
            this.C.position.copy(args.position).lerp(this.B.position, 0.5);
        });
        this.B.bindEvent('onDragMove', (args) => {
            this.C.position.copy(args.position).lerp(this.A.position, 0.5);
        });
        this.C.bindEvent('onDragMove', (args) => {
            this._pan.copy(this.C.position).sub(args.position);
            this.A.position.sub(this._pan);
            this.B.position.sub(this._pan);
        });
    }
    update() {
        this.lengthLabel.setParam('text', FormatUtils.distanceWithSymbol(this.distance));
    }
    /**
     * Gets the points to init line to the camera center.
     */
    static getPoints(cameraCenter) {
        const dir = Consts.verDir.clone().setLength(50);
        return {
            A: cameraCenter.clone().setZ(3).add(dir),
            B: cameraCenter.clone().setZ(3).sub(dir)
        };
    }
    setPoints(A, B) {
        this.A.position.copy(A);
        this.B.position.copy(B);
        this.C.position.copy(A).lerp(B, 0.5);
        this.update();
    }
}
__decorate([
    Save('position')
], MeasurementLine.prototype, "A", void 0);
__decorate([
    Save('position')
], MeasurementLine.prototype, "B", void 0);
__decorate([
    Save('position')
], MeasurementLine.prototype, "C", void 0);
__decorate([
    SaveChild()
], MeasurementLine.prototype, "lengthLabel", void 0);
__decorate([
    Save()
], MeasurementLine.prototype, "_pan", void 0);
//# sourceMappingURL=MeasurementLine.js.map